module.exports = __webpack_public_path__ + "img/76157.054b07c5.svg";